import GenericAction from '@Actions/generic-action';
import { clearAuthLocalStorage, clearAuthSessionStorage } from "@Helpers/clear-auth-session-storage";
import { Actions, Events } from '@Context/common/general/context';
import initialState from '@Context/common/general/initial-state';
import { AnalyticsEvents } from '@Enums';
import * as Sentry from "@sentry/react";
import { getAuth } from 'firebase/auth';

export default class Logout extends GenericAction {
  runAction() {
    const Action = async () => {
      try {
        await getAuth().signOut();
        // Clear amp & sentry data
        // this._amplitude.clearUserProperties();
        Sentry.setUser(null);

        // Update app state
        this._dispatch({
          type: Actions.CoreActions.UpdateState,
          payload: {
            user: initialState.user,
            account: initialState.account,
          },
        });
        // Send analytics event
        this._dispatch({
          type: Actions.AppActions.AnalyticsEvent,
          payload: { type: AnalyticsEvents.user_logout }
        });
        // Update Account info for Unity bridge purposes
        if (this._state.auth.events.accountInfoUpdated) {
          this._state.auth.events.accountInfoUpdated.emit(null);
        }
        // Clear storage for this session
        clearAuthLocalStorage();
        clearAuthSessionStorage();

        Events.auth.logout.emit();
        
        // Force navigate app to root path
        this._dispatch({
          type: Actions.AppActions.Navigate,
          payload: {
            path: '/',
          },
        });
        super.onSuccess();
        return Promise.resolve();
      } catch (error) {
        super.onError(error);
        return Promise.reject(error);
      }
    };
    Action();
  }
}
